module.exports = __webpack_public_path__ + "media/country_flags/pk-8fcb4fbb.png";